// Applies SCF brand fonts and colors inside the Shopify Forms embed's shadow DOM.
document.addEventListener('DOMContentLoaded', () => {
  const formSelector = '#app-embed-container-14488';

  const observer = new MutationObserver((_mutations, obs) => {
    const form = document.querySelector(formSelector);
    if (!form || !form.shadowRoot) return;

    try {
      const sheet = new CSSStyleSheet();
      [
        ':host { --forms-body-font: "museo_sans_rounded500" !important; }',
        'h2, h3 { font-family: "museo_sans_rounded900" !important; }',
        'p { font-family: var(--main-font-stack) !important; }',
        'input { background-color: #FFF5E3 !important; }',
        'button { color: #C73534 !important; text-transform: uppercase !important; font-family: "museo_sans_rounded900" !important; }',
      ].forEach((rule) => sheet.insertRule(rule));
      form.shadowRoot.adoptedStyleSheets = [...form.shadowRoot.adoptedStyleSheets, sheet];
      form.classList.add('loaded');
    } catch (error) {
      console.error('Error applying styles to the form:', error);
    } finally {
      obs.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
